<template>
  <el-form ref="form" :model="node" :rules="rules" >
    <el-form-item label="Type" >
      <el-radio-group v-model="type" >
        <el-radio label="file" :border="true" >
          Fichier
          <i class="el-icon-fa-file"/>
        </el-radio>
        <el-radio label="dir" :border="true" >
          Dossier
          <i class="el-icon-fa-folder-open"/>
        </el-radio>
      </el-radio-group>
    </el-form-item>
    <el-form-item v-if="type === 'file'" label="Fichier" prop="file" >
      <el-upload
         ref="uploader"
         :drag="true"
         :action="uploadURL"
         :headers="uploadHeaders"
         :on-success="uploadSuccess"
         :on-remove="uploadRemove"
         :multiple="false" >
        <i class="el-icon-upload"></i>
        <div class="el-upload__text">Glisser un fichier ou <em>cliquer pour uploader</em></div>
      </el-upload>
    </el-form-item>
    <el-form-item label="Nom" prop="name" >
      <el-input v-model="node.name" @change="manualName = true" ></el-input>
    </el-form-item>
    <el-form-item>
      <el-button type="warning" @click="cancel" icon="el-icon-circle-close" >
        Annuler
      </el-button>
      <el-button type="primary" @click="submit" icon="el-icon-circle-check" >Valider</el-button>
    </el-form-item>
  </el-form>
</template>

<script>
import {NodeVersion} from '../entity'
import {api} from 'macarons'

export default {
  props: {
    value: {
      required: true,
      type: NodeVersion
    },
    dir: {
      type: NodeVersion,
      required: false
    }
  },
  data () {
    return {
      type: this.value.id ? this.value.type : 'file',
      node: this.value,
      manualName: !!this.value.id
    }
  },
  watch: {
    value () {
      this.node = this.value
      this.type = this.value.id ? this.value.type : 'file'
      this.manualName = !!this.value.id
    }
  },
  computed: {
    rules () {
      const rules = {
        name: [
          { required: true, message: 'Le nom est requis', trigger: 'blur' },
          {
            min: 1,
            max: 255,
            message: 'Le nom doit faire entre 1 et 255 caractères',
            trigger: 'blur'
          }
        ]
      }
      if (this.type === 'file') {
        rules.file = [
          { required: true, message: 'Le fichier est obligatoire', trigger: 'change' }
        ]
      }
      return rules
    },
    uploadURL () {
      return api.defaults.baseURL.replace(/\/+$/g, '') + '/file/upload'
    },
    uploadHeaders () {
      return {
        'X-Auth-Token': this.$store.state.token
      }
    }
  },
  methods: {
    uploadSuccess (response, file, fileList) {
      fileList.splice(0, fileList.length - 1)
      this.node.file = response.file
      if (!this.manualName) {
        this.node.name = response.file.name
      }
    },
    uploadRemove (file, fileList) {
      this.node.file = null
      if (!this.manualName) {
        this.node.name = null
      }
    },
    cancel () {
      if (typeof this.$refs.uploader !== 'undefined') {
        this.$refs.uploader.clearFiles()
      }
      this.$emit('cancel')
    },
    submit () {
      this.$refs.form.validate(valid => {
        if (valid) {
          api[this.node.id ? 'patch' : 'put'](
            'fs/node' + (this.node.id ? '/' + this.node.node.id : ''),
            {
              name: this.node.name,
              file: this.node.file ? this.node.file.id : null,
              parent: this.dir ? this.dir.node.id : null
            }
          ).then(({data}) => {
            this.$emit('input', this.node)
          }).catch(() => {
            this.$notify.error({
              title: 'Erreur',
              message: 'Une erreur est survenue pendant la création'
            })
            this.$emit('error')
          })
        }
      })
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/files/components/NodeVersionForm.vue